var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentBox == 0)?_c('inbox-table',{on:{"getDetailId":_vm.goToDetail}}):_vm._e(),(_vm.currentBox == 1)?_c('outbox-table',{on:{"getDetailId":_vm.goToDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }